import { Fragment } from "react/jsx-runtime";
import { EditCompanyProps } from "../../Utils/Types";
import { Controller } from "react-hook-form";
import {
  Autocomplete,
  AutocompleteChangeReason,
  TextField,
} from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import {
  getSameWidthPopperSlotProps,
  getValueForAutocomplete,
  isMobile,
} from "../../Utils/Utils";

export default function EditCompany(props: EditCompanyProps) {
  const { companies, control } = props;

  return (
    <Fragment>
      <Controller
        name={`companyId`}
        control={control}
        defaultValue={null}
        render={({ field: { ref, ...field }, fieldState: { error } }) => {
          return (
            <>
              <Autocomplete
                size="small"
                disableClearable
                id={`companyId`}
                fullWidth={true}
                freeSolo={false}
                noOptionsText={Vocabulary.noResultsFound}
                slotProps={getSameWidthPopperSlotProps()}
                isOptionEqualToValue={(option: any, value: any) => {
                  if (typeof value === "string") {
                    return option._id === value;
                  } else {
                    return option?._id === value?._id;
                  }
                }}
                getOptionLabel={(option: any) => option.name}
                options={companies || []}
                value={getValueForAutocomplete(companies, field.value)}
                onChange={(
                  e: any,
                  product: string,
                  reason: AutocompleteChangeReason,
                  details?: any
                ) => {
                  field.onChange(details.option._id);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputProps={{
                      style: {
                        minWidth: isMobile() ? "100%" : "20vw",
                      },
                      ...params.InputProps,
                      rows: 4,
                      multiline: false,
                      inputComponent: "textarea",
                    }}
                    fullWidth={true}
                    name={`companyId`}
                    label={Vocabulary.company}
                    variant="standard"
                  />
                )}
              />
            </>
          );
        }}
      />
    </Fragment>
  );
}
